// Our API has a different pattern from Comscore
// Only birthdate is enough
import { isNullable } from "@/types/isNullable";
import type { Profile } from "@/utils/hooks/useProfile";

const ageGroupCode = "00";
const birthdateCode = (birthdate?: string): string => {
  if (isNullable(birthdate)) {
    return "00000000";
  }
  return birthdate.replace(/-/g, "");
};

const genderCode = (gender?: string) => {
  switch (gender) {
    case "Unspecified": // this is now the API default that should be fixed
    case "Other":
    case "Prefer not to say":
      return "3";
    case "Female":
      return "2";
    case "Male":
      return "1";
    default:
      return "0";
  }
};

export const getComscoreDemographicCode = (
  profile?: Profile,
): string | null => {
  if (isNullable(profile)) {
    return null;
  }

  if (
    isNullable(profile.dob) &&
    (isNullable(profile.gender) || profile.gender === "Unspecified")
  ) {
    return null;
  }
  const demographicString =
    birthdateCode(profile.dob) + ageGroupCode + genderCode(profile.gender);
  const demographicNumber = parseInt(demographicString);
  return `${demographicNumber + 19991999999}`;
};
